"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STOPPING = exports.STOPPED = exports.STARTING = exports.STARTED = exports.PENDING = void 0;
var PENDING = exports.PENDING = 'PENDING';
var STARTING = exports.STARTING = 'STARTING';
var STARTED = exports.STARTED = 'STARTED';
var STOPPING = exports.STOPPING = 'STOPPING';
var STOPPED = exports.STOPPED = 'STOPPED';